import { CitationItem } from '@/common/model/media/citation'

// 自社=青系 / 競合=橙系。チャートの系列色
export const CITATION_BRAND_COLORS = [
  '#6ECBFA',
  '#FFB800',
  '#EAF200',
  '#A98FFF',
  '#57C6B1'
] as const

// URL からドメインを抽出（www. 除去）。不正なURLは null
export const extractDomain = (url: string): string | null => {
  try {
    return new URL(url).hostname.replace('www.', '')
  } catch {
    return null
  }
}

// 言及元ページのカテゴリ別件数を集計
export const countByCategory = (citations: CitationItem[]): Record<string, number> => {
  const counts: Record<string, number> = {}
  citations.forEach((c) => {
    if (c.category) counts[c.category] = (counts[c.category] || 0) + 1
  })
  return counts
}

// AIが返す文章を句点で分割して箇条書きにする（末尾の句点は残す）
export const toSentences = (text: string | undefined): string[] =>
  (text ?? '')
    .split(/(?<=。)/)
    .map((s) => s.trim())
    .filter(Boolean)

// カテゴリ一覧（昇順）
export const uniqueCategories = (citations: CitationItem[]): string[] =>
  [...new Set(citations.map((c) => c.category).filter(Boolean))].sort()

// ファビコンURL（Google s2）
export const faviconUrl = (domain: string): string =>
  `https://www.google.com/s2/favicons?domain=${domain}`

// -----------------------------------------------
// よく利用するドメイン・ブランド名（localStorage 共有）
// 競合分析（competitor）とキーを共有する
// -----------------------------------------------

const FAV_DOMAIN_KEY = 'competitor_favorite_domains'
const FAV_BRAND_KEY = 'favorite_brands'

const loadList = (key: string): string[] => {
  try {
    const v = JSON.parse(localStorage.getItem(key) || '[]')
    return Array.isArray(v) ? v : []
  } catch {
    return []
  }
}

const saveList = (key: string, list: string[]): string[] => {
  const uniq = [...new Set(list.map((d) => d.trim()).filter(Boolean))]
  localStorage.setItem(key, JSON.stringify(uniq))
  return uniq
}

export const loadFavoriteDomains = (): string[] => loadList(FAV_DOMAIN_KEY)
export const loadFavoriteBrands = (): string[] => loadList(FAV_BRAND_KEY)

// お気に入りのトグル（追加/削除した結果のリストを返す）
export const toggleFavoriteDomain = (current: string[], domain: string): string[] => {
  const d = domain.trim()
  if (!d) return current
  const next = current.includes(d) ? current.filter((x) => x !== d) : [...current, d]
  return saveList(FAV_DOMAIN_KEY, next)
}

export const toggleFavoriteBrand = (current: string[], brand: string): string[] => {
  const b = brand.trim()
  if (!b) return current
  const next = current.includes(b) ? current.filter((x) => x !== b) : [...current, b]
  return saveList(FAV_BRAND_KEY, next)
}
